import { useEffectEvent, useLayoutEffect, useState } from 'react';

export const usePortal = (
  id: string,
  options?: { replace: boolean; style?: Partial<CSSStyleDeclaration> }
) => {
  const { replace = false, style } = options || {};
  const [rootEl] = useState(() => {
    return document.createElement('div');
  });

  const addPortalToParentEl = useEffectEvent(() => {
    let parentEl = document.querySelector(`#${id}`);
    if (!parentEl) {
      parentEl = document.createElement('div');
      parentEl.id = id;
      document.body.appendChild(parentEl);
    }
    if (replace && parentEl.firstChild) {
      parentEl.replaceChild(rootEl, parentEl.firstChild);
    } else {
      parentEl.appendChild(rootEl);
    }
  });

  useLayoutEffect(() => {
    addPortalToParentEl();
    return () => {
      rootEl.remove();
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [rootEl]);

  useLayoutEffect(() => {
    if (style && rootEl) {
      Object.assign(rootEl.style, style);
    }
  }, [style, rootEl]);

  return rootEl;
};
